import React from 'react';
// actions
import { goBack } from 'src/containers/AddSkuPage/QuestionsFlowPage/actions';
// context
import { useQAContext } from 'src/containers/AddSkuPage/QuestionsFlowPage/Context';
import Icon from 'HTKit/Icon';
import styles from 'src/containers/AddSkuPage/QuestionsFlowPage/styles.scss';

const BackComponent = () => {
  const [contextState, contextDispatch] = useQAContext();

  /* No back button on first panel */
  if (contextState.questionPath.length < 2) {
    return null;
  }

  return (
     <Icon
       onClick={() => {
       contextDispatch(goBack());
     }} name="v2-skinny-arrow-right" className={styles.chevronIcon} />
  )
}


export default BackComponent;
